<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.99603 12.2088L13.8954 17.0966C14.3824 17.707 15.366 17.3726 15.3801 16.592L15.6174 3.43766C15.6293 2.77816 14.9067 2.36691 14.3458 2.71398L3.11154 9.66526C2.45297 10.0728 2.65786 11.0798 3.4233 11.1975L9.99603 12.2088ZM9.99603 12.2088L15.1805 2.81237" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>
    </svg>
</template>
